/** Shared column geometry keeps every result's name on the same scan line. */
export const searchIdentityLayout =
  'grid min-h-14 min-w-0 flex-1 grid-cols-[32px_minmax(0,1fr)] items-center gap-x-3 gap-y-0 py-2 text-left text-sm sm:grid-cols-[32px_80px_minmax(0,1fr)] sm:py-0';
export const searchCodeStyle =
  'min-w-0 truncate font-mono text-xs font-medium leading-5 text-foreground sm:text-[13px]';
export const searchNameStyle =
  'col-start-2 flex min-w-0 items-center gap-2 font-normal leading-5 sm:col-start-3';
